<template>
  <el-dialog
    :visible.sync="visited"
    title="查看付费"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    append-to-body
    v-loading.fullscreen="loading"
    element-loading-text="正在获取信息"
    width="400px">
    <div>
      <div class="beVip">
        非会员：￥{{viewPrice}}<span style="margin-left: 20px"></span>
        会员：￥<span style="color:red">{{viewVipPrice}}</span>
        <img  v-if="!vipInfo" class="beVipImg" src="@/assets/img/vip/bevip.png" @click="openVipPop"/>
        <!--<el-link style="top: -3px;" type="danger" v-if="!vipInfo" @click="openVipPop">（开通会员）</el-link>-->
        <div style="text-align: center;margin-top: 20px">
          <el-radio v-model="payType" label="0">微信</el-radio>
          <el-radio v-model="payType" label="1">支付宝</el-radio>
        </div>
        <div style="text-align: center">
          <img :src="qrcode">
          <el-button size="medium" type="text" @click="getPayQrcode">刷新二维码</el-button>
        </div>

      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { getResourcePrice, getPayQrcode, getInfo } from '@/api/resource/resourceview'
export default {
  data () {
    return {
      url: window.location.href,
      loading: false,
      sendSampleDialogVisible: false,
      canClick: true, // 添加canClick
      totalTime: 300,
      visited: false,
      next: '',
      to: '', // 可以接受参数
      params: { tableType: '', rowId: '' },
      viewPrice: '',
      viewVipPrice: '',
      payType: '0',
      qrcode: '',
      prevTid: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  watch: {
    'vipInfo': function () {
      if (this.visited) {
        this.getPayQrcode()
      }
    },
    'payType': function () {
      this.getPayQrcode()
    },
    'visited': function (newValue, oldValue) {
      if (!newValue) {
        clearInterval(this.prevTid)
      }
    }
  },
  mounted () {
    this.getResourcePrice()
    // 获取二维码
    this.getPayQrcode()
    this.prevTid = setInterval(this.getOrderInfo, 3000)
  },
  beforeDestroy () {
    clearInterval(this.prevTid)
  },
  methods: {
    ...mapActions(['handleLogin']),
    openVipPop () {
      this.vip({
        next: function () {},
        payClose: true
      })
    },
    show () {
      this.visited = true
    },
    getResourcePrice () {
      getResourcePrice(this.params)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.viewPrice = result.bizData.viewPrice
            this.viewVipPrice = result.bizData.viewVipPrice
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    getPayQrcode () {
      var pam = {}
      pam.tableType = this.params.tableType
      pam.rowId = this.params.rowId
      pam.payType = this.payType
      getPayQrcode(pam)
        .then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.qrcode = result.bizData.qrcode
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('获取支付二维码异常')
        })
    },
    getOrderInfo () {
      getInfo(this.params).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData.right) {
            clearInterval(this.prevTid)
            this.next()
            this.visited = false
          }
        }
      }).catch(ex => {
        this.$message.error('获取支付宝验证码失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-container {
    margin: 0px auto;
    padding: 0 15px 15px 15px;
    background: #fff;
    text-align: left;
  }
  .beVip {
    position: relative;
    .beVipImg {
      height: 30px;
      margin-left: 11px;
      position: relative;
      top: 7px;
    }
    .beVipImg:hover {
      cursor: pointer;
    }
  }
</style>
